import { render, staticRenderFns } from "./btnContinue.vue?vue&type=template&id=35c47e42&scoped=true&"
import script from "./btnContinue.vue?vue&type=script&lang=js&"
export * from "./btnContinue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c47e42",
  null
  
)

export default component.exports